module.exports = __webpack_public_path__ + "e560612608eca8b014d8966920977c8f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/areas/areas-affordable-housing-circle.png
// module id = 117
// module chunks = 0